import "./App.scss";
import { useRef, createContext, useState } from "react";
import Home from "./components/Home";
import "./styles/locomotive-scroll.css";
import { LocomotiveScrollProvider } from "react-locomotive-scroll";
import { AnimatePresence } from "framer-motion";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer/Footer";
import SocialMediaBar from "./components/SocialMedia/SocialMediaBar";
import Testimonial from "./components/Testimonial/Testimonial";

export const FormContext = createContext();

function App() {
  const containerRef = useRef(null);
  const [formOpen, setFormOpen] = useState(false);
  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
        mobile: {
          smooth: true,
        },
        // ... all available Locomotive Scroll instance options
      }}
      watch={
        [
          //..all the dependencies you want to watch to update the scroll.
          //  Basicaly, you would want to watch page/location changes
          //  For exemple, on Next.js you would want to watch properties like `router.asPath` (you may want to add more criterias if the instance should be update on locations with query parameters)
        ]
      }
      containerRef={containerRef}
    >
      <AnimatePresence>
        <FormContext.Provider value={{ formOpen, setFormOpen }}>
          <main
            className={`main App ${formOpen ? "formOpen" : ""}`}
            data-scroll-container
            ref={containerRef}
          >
            <Home data-scroll-section />
            <About data-scroll-section />
            <Skills data-scroll-section />
            <Projects />
            <Testimonial />
            <Footer />
          </main>
        </FormContext.Provider>
        <SocialMediaBar />
      </AnimatePresence>
    </LocomotiveScrollProvider>
  );
}

export default App;
